import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronDownOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m12 17.273-8-8L5.273 8 12 14.727 18.727 8 20 9.273z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronDownOutlinedSize24Glyph.displayName = 'ChevronDownOutlinedSize24Glyph';
